import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "header-mobile-menu" }
const _hoisted_2 = { class: "mt-s3 text-center" }
const _hoisted_3 = { class: "flex flex-column align-items-center mt-s7" }
const _hoisted_4 = { class: "mt-s6" }
const _hoisted_5 = { class: "mx-auto mt-s10" }

import { useStore } from 'vuex';
import { ref } from 'vue';
import MainMenu from './MainMenu.vue';
import Wallet from '../wallet/Wallet.vue';
import FooterMenu from '../footer/FooterMenu.vue';
import CommunityIcons from '../footer/CommunityIcons.vue';
import Copyright from '../footer/Copyright.vue';
import InfoPanel from '../footer/InfoPanel.vue';
import NetworkSelect from '@/views/layout/header/NetworkSelect.vue';
import { fixOverlayPosition } from '@/composables/utils/useUtils';
import { APP_NETWORK_NAME } from '@/helpers/networkParams.helper';
import ThemeSwitch from '@/components/ThemeSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMobileMenu',
  setup(__props) {

const { state } = useStore();

const isMenuOpen = ref(false);
const mobileMenu = ref();

const onMenuToggle = event => {
  isMenuOpen.value = !isMenuOpen.value;
  mobileMenu.value.toggle(event);
};
const onMenuClose = () => {
  isMenuOpen.value = false;
  mobileMenu.value.hide();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      type: "button",
      class: "button-control-icon button-no-hover",
      icon: isMenuOpen.value ? 'pi pi-times' : 'pi pi-bars',
      onClick: onMenuToggle,
      "aria-controls": `${_unref(state).layout.viewMode}Menu`
    }, null, 8, ["icon", "aria-controls"]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "mobileMenu",
      ref: mobileMenu,
      id: `${_unref(state).layout.viewMode}Menu`,
      dismissable: false,
      onShow: _cache[0] || (_cache[0] = ($event: any) => (_unref(fixOverlayPosition)(`#${_unref(state).layout.viewMode}Menu`)))
    }, {
      default: _withCtx(() => [
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createBlock(NetworkSelect, {
              key: 0,
              "current-network": _unref(APP_NETWORK_NAME),
              class: "mb-s3"
            }, null, 8, ["current-network"]))
          : _createCommentVNode("", true),
        _createVNode(MainMenu, { onClick: onMenuClose }),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(Wallet)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(InfoPanel),
                _createVNode(FooterMenu, { class: "mt-s10" }),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(ThemeSwitch, { class: "mx-auto" })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CommunityIcons)
                ]),
                _createVNode(Copyright, { class: "mt-s10" })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["id"])
  ]))
}
}

})